import PropTypes from "prop-types";
const StarRating = ({ rating }) => {
    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            {[1, 2, 3, 4, 5].map((star) => (
                <span
                    key={star}
                    style={{
                        color: star <= rating ? "#ffc107" : "#e4e5e9",
                        marginRight: "2px",
                    }}
                >
          ★
        </span>
            ))}
        </div>
    )
}

StarRating.propTypes = {
    rating: PropTypes.number.isRequired,
}

export default StarRating;